import {PRODUIT_ROUTES as produitRoutes, SALON_ROUTES as salonRoutes} from "~/api/routes";
export const state = () => ({
  salons: [],
  products: null,
  close: false,
});
export const getters = {
  salons: state =>{
    return state.salons;
  },
  products: state =>{
    if (state.products)
    {
      let names = [];
      state.products.prestations.map(p =>{
        names.push(p.nom);
      });
      state.products.produits.map(p =>{
        names.push(p.nom);
      });
      return names;
    }
    return [];
  }
};
export const mutations = {
  CLOSE_MODAL(state, params){
    state.close = params;
  },
  SET_SALON(state, params){
    state.salons = params;
  },
  SET_PRODUCTS(state, params){
    state.products = params;
  },
  ADD_SALON(state, params){
    params.active = false;
    state.salons.push(params);
  },
  DELETE_SALON(state, params){
    state.salons = state.salons.filter(t => t.salon_id !== params);
  },
  UPDATE_SALON(state, params){
    state.salons = state.salons.map(t => {
      if (t.salon_id === params.salon_id)
        return params;
      return t;
    })
  },
  ACTIVATE_SALON(state, params){
    state.salons = state.salons.map(t => {
      if (t.salon_id == params)
        t.active = !t.active;
      else
        t.active = false;
      return t;
    })
  },
  SALON_DRAFT(state, params){
    salon = state.salons_drafts.indexOf(e => {
      return e.salon_id === params.salon_id
    });

    if(salon)
      state.salons_drafts
  },
};
export const actions = {
  list({commit}, params){
    return new Promise((resolve, reject)=>{
      this.$api.request(salonRoutes.list).then((res)=>{
        commit('SET_SALON', res.payload);
        resolve();
      }).catch(() =>{

      });
    });
  },
  listProducts({commit}, params){
    return new Promise((resolve, reject)=>{
      this.$api.request(salonRoutes.productsAndPrestations).then((res)=>{
        commit('SET_PRODUCTS', res.payload);
        resolve();
      }).catch(() =>{

      });
    });
  },
  create({commit}, params){
    commit('CLOSE_MODAL', false);
    return new Promise((resolve, reject)=>{
      this.$api.request(salonRoutes.create, {}, params).then((res)=>{
        commit('ADD_SALON', res.payload);
        commit('CLOSE_MODAL', true);
        resolve();
      }).catch((err) =>{
        let res = err.response ? err.response.data._response : null;
        commit('CLOSE_MODAL', false);
        reject(res);
      });
    });
  },
  activate({commit}, params){
    return new Promise((resolve, reject)=>{
      this.$api.request(salonRoutes.activate, {id: params.id}).then((res)=>{
        commit('ACTIVATE_SALON', params.id);
        resolve(res._response.message);
      }).catch((err) =>{
        if (err.response)
          reject(err.response._response.message);
        else
          reject('Une erreur est survenue');
      });
    });
  },
  delete({commit}, params){
    return new Promise((resolve, reject)=>{
      this.$api.request(salonRoutes.delete, {id: params.salon_id},).then((res)=>{
        commit('DELETE_SALON', params.salon_id);
        resolve();
      }).catch(() =>{

      });
    });
  },
  update({commit}, params){
    commit('CLOSE_MODAL', false);

    return new Promise((resolve, reject)=>{
      this.$api.request(salonRoutes.update, {id: params.id},params.fd).then((res)=>{
        commit('UPDATE_SALON', res.payload);
        resolve();
      }).catch((err) =>{
        let res = err.response ? err.response.data._response : null;
        commit('CLOSE_MODAL', false);
        reject(res);
      });
    });
  },
  previewDraft({commit}, params) {
    commit('CLOSE_MODAL', false);

    return new Promise((resolve, reject) => {
      this.$api.request(salonRoutes.preview_draft, {id: params.id}).then((res)=>{
        // Redirect To Marketplace

        resolve();
      }).catch(() => {
        commit('CLOSE_MODAL', false);
      });
    })
  },
  applyDraft({commit}, params) {
    commit('CLOSE_MODAL', false);

    return new Promise((resolve, reject) => {
      this.$api.request(salonRoutes.apply_draft, {id: params.id}).then((res)=>{
        commit('UPDATE_SALON', res.payload);
        commit('CLOSE_MODAL', true);
        resolve();
      }).catch(() => {
        commit('CLOSE_MODAL', false);
      });
    })
  },
  closeModal({commit}, params){
    commit('CLOSE_MODAL', params);
  }
};
